import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

export type RdProjectEligibilityIds = {
  consideredForRdToggleId: string;
};

export const useRdProjectEligibilityIds = (): RdProjectEligibilityIds => ({
  consideredForRdToggleId: useAnalyticId(AnalyticIdentifier.PROJECT_RD_ELIGIBLE_TOGGLE),
});
